module.exports = __webpack_public_path__ + "static/media/layout-four-3.34c6010a.jpg";